// MUST be imported before anything else in main.tsx so Sentry can install
// its global error handlers and instrument fetch before any app code runs.
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
const apiUrl = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000'

// Browser noise we never want to capture: framework-internal harmless errors and
// user-initiated aborts (e.g. navigating away mid-fetch).
const IGNORED_ERROR_PATTERNS = [
  /ResizeObserver loop/i,
  /Non-Error promise rejection captured/i,
  /AbortError/i,
]

if (dsn) {
  Sentry.init({
    dsn,
    environment: (import.meta.env.MODE as string | undefined) ?? 'development',
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Add the backend origin so distributed tracing headers are attached to API calls
    tracePropagationTargets: [apiUrl],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
    ignoreErrors: IGNORED_ERROR_PATTERNS,
  })
}
